export default function swapKV(hashMap) {
  return Object.keys(hashMap).reduce(
    (acc, curr) => ({
      ...acc,
      [hashMap[curr]]: curr,
    }),
    {}
  );
}



// WEBPACK FOOTER //
// ./app/utils/object/swapKV.js